import React from "react";
import { useNavigate } from "react-router-dom";
import { CircleAlert } from "lucide-react";

const NotFound = ({ heading = "Profile Not Available", subtext = "This profile may have been deleted or no longer exists.", buttonText = "Discover More on Wryven", buttonRoute = "/explore" }) => {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate(buttonRoute);
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen px-4 text-center">
      
      {/* Circle Alert Icon */}
      <div className="w-24 h-24 flex items-center justify-center rounded-full bg-gray-50 mb-6">
        <CircleAlert className="w-12 h-12 text-black" />
      </div>

      {/* Heading */}
      <h2 className="text-xl font-semibold mb-2 text-black">
        {heading}
      </h2>

      {/* Subtext */}
      <p className="text-gray-500 mb-6 max-w-sm">
        {subtext}
      </p>

      {/* Button */}
      <button 
        onClick={handleButtonClick}
        className="px-6 py-2 font-semibold bg-[#b0d284] text-black hover:bg-[#9ec170] transition-all duration-200 active:scale-95 rounded-full"
      >
        {buttonText}
      </button>
    </div>
  );
};

export default NotFound;